module.exports = __webpack_public_path__ + "img/carousel2.a7dfd3b1.png";